import { render, staticRenderFns } from "./CutText.vue?vue&type=template&id=698b3d28&"
import script from "./CutText.vue?vue&type=script&lang=js&"
export * from "./CutText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports